import styled from 'styled-components';

import MenuItem from 'components/Header/Desktop/MenuItem';

import type { FC } from 'react';

type DesktopMenuProps = {
  elementMenu?: any[];
  isMobileNavOpen?: boolean;
  openMenu?: number;
  setOpenMenu?: () => void;
  handleMenuClick?: (menuIndex: number) => void;
  setIsMobileNavOpen?: () => void;
};

const DesktopMenu: FC<DesktopMenuProps> = ({ elementMenu, openMenu, setOpenMenu, handleMenuClick }) => (
  <Container>
    <ul className="desktop-parent-nav">
      {elementMenu?.map((parent, index) => (
        <li key={`menu item ${parent?.heading}`}>
          <MenuItem
            key={`menu item ${parent?.heading}`}
            menu={parent}
            isOpen={index === openMenu}
            onClick={() => handleMenuClick && handleMenuClick(index)}
            onMouseEnter={() => handleMenuClick && handleMenuClick(index)}
            setOpenMenu={setOpenMenu}
          />
        </li>
      ))}
    </ul>
  </Container>
);

export default DesktopMenu;

const Container = styled.div`
  background-color: common-white;
  flex-direction: column;
  height: 0;
  justify-content: space-between;
  left: 0;
  overflow-x: hidden;
  overflow-y: auto;
  position: absolute;
  top: 100%;
  transition: height 0s ease-in-out;
  width: 100%;
  z-index: 10;

  .desktop-parent-nav {
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-direction: row;
    gap: 0;
    gap: 24px;
    list-style: none;
    margin: 0;
    min-height: 96px;
    min-width: 100%;
    padding: 0;
    width: 100%;
    width: auto;
    z-index: 10;
  }

  li {
    position: relative;
  }

  @media (max-width: 991px) {
    display: none;
  }

  @media (min-width: 992px) {
    align-items: center;
    backgroundcolor: common-transparent;
    display: flex;
    flex-direction: row;
    min-height: 96px;
    overflow-x: unset;
    overflow-y: unset;
    position: unset;
    width: auto;
  }
`;
